import { experimentalAboutConfluence } from './queries/experimentalAboutConfluence';
import { experimentalAnalyticsActivityBySpace } from './queries/experimentalAnalyticsActivityBySpace';
import { experimentalAutomationRuleConnections } from './queries/experimentalAutomationRuleConnections';
import { experimentalAutomationRuleSummary } from './queries/experimentalAutomationRuleSummary';
import { experimentalContentDraftDiff } from './queries/experimentalContentDraftDiff';
import { experimentalDesPromotionEligibility } from './queries/experimentalDesPromotionEligibility';
import { experimentalOpenInvite } from './queries/experimentalOpenInvite';
import { experimentalGenerateSpaceKey } from './queries/experimentalGenerateSpaceKey';
import { experimentalGetCompleteOnboarding } from './queries/experimentalGetCompleteOnboarding';
import { experimentalKeyboardShortcutsStatus } from './queries/experimentalKeyboardShortcutsStatus';
import { experimentalMacroMetadata } from './queries/experimentalMacroMetadata';
import { experimentalMacroPlaceholderADF } from './queries/experimentalMacroPlaceholderADF';
import { experimentalPromotedSpaces } from './queries/experimentalPromotedSpaces';
import { experimentalOnboardingSpaceBlueprints } from './queries/experimentalOnboardingSpaceBlueprints';
import { experimentalOnboardingTemplate } from './queries/experimentalOnboardingTemplate';
import { experimentalSpace } from './queries/experimentalSpace';
import { experimentalSpaceProperties } from './queries/experimentalSpaceProperties';
import { experimentalLongTask } from './queries/experimentalLongTask';
import { experimentalSynchronySnapshot } from './queries/experimentalSynchronySnapshot';
import { experimentalSynchronyJwt } from './queries/experimentalSynchronyJwt';
import { experimentalResolvedInlineComments } from './queries/experimentalResolvedInlineComments';
import { experimentalEditorBreadcrumbs } from './queries/experimentalEditorBreadcrumbs';
import { experimentalCurrentUser } from './queries/experimentalCurrentUser';
import { experimentalSystemInfoSettings } from './queries/experimentalSystemInfoSettings';
import { experimentalDefaultLogoForSpace } from './queries/experimentalDefaultLogoForSpace';
import { experimentalRelationsForContent } from './queries/experimentalRelationsForContent';
import { experimentalAddPersonalSpaceLink } from './mutations/experimentalAddPersonalSpace';
import { experimentalAddSpaceLink } from './mutations/experimentalAddSpaceLink';
import { experimentalAddCustomizedPersonalSpace } from './mutations/experimentalAddCustomizedPersonalSpace';
import { experimentalCopyPageTree } from './mutations/experimentalCopyPageTree';
import { experimentalCreateDemoSpace } from './mutations/experimentalCreateDemoSpace';
import { experimentalCreateSpecificSpace } from './mutations/experimentalCreateSpecificSpace';
import { experimentalDeleteComment } from './mutations/experimentalDeleteComment';
import { experimentalDeleteContentVersion } from './mutations/experimentalDeleteContentVersion';
import {
	experimentalDisableKeyboardShortcuts,
	experimentalEnableKeyboardShortcuts,
} from './mutations/experimentalSetKeyboardShortcutsEnabled';
import { experimentalFavouriteSpace } from './mutations/experimentalFavouriteSpace';
import { experimentalGrantAccess } from './mutations/experimentalGrantAccess';
import { experimentalCreateAutomationRuleFromTemplate } from './mutations/experimentalCreateAutomationRuleFromTemplate';
import { experimentalCreateBlankFabricPage } from './mutations/experimentalCreateBlankFabricPage';
import { experimentalCreateFabricBlogpost } from './mutations/experimentalCreateFabricBlogpost';
import { experimentalPublishPageByBlueprint } from './mutations/experimentalPublishPageByBlueprint';
import { experimentalUpdateDraftWithBlueprint } from './mutations/experimentalUpdateDraftWithBlueprint';
import { experimentalPublishPageByTemplate } from './mutations/experimentalPublishPageByTemplate';
import { experimentalUpdateDraftWithTemplate } from './mutations/experimentalUpdateDraftWithTemplate';
import { experimentalRemoveSpaceLink } from './mutations/experimentalRemoveSpaceLink';
import { experimentalRequestAccess } from './mutations/experimentalRequestAccess';
import { experimentalShare } from './mutations/experimentalShare';
import { experimentalRestoreContentVersion } from './mutations/experimentalRestoreContentVersion';
import { experimentalSetFeatureDiscovered } from './mutations/experimentalSetFeatureDiscovered';
import { experimentalSubmitFeedbackCollector } from './mutations/experimentalSubmitFeedbackCollector';
import { experimentalUnfavouriteSpace } from './mutations/experimentalUnfavouriteSpace';
import { experimentalUpdateDesSettings } from './mutations/experimentalUpdateDesSettings';
import { experimentalUpdateOpenInviteSettings } from './mutations/experimentalUpdateOpenInviteSettings';
import { experimentalUpdateShortcutLinks } from './mutations/experimentalUpdateShortcutLinks';
import { experimentalUpdateSpaceLogo } from './mutations/experimentalUpdateSpaceLogo';
import { experimentalCrossProductAdvancedSearch } from './queries/experimentalCrossProductAdvancedSearch';
import { experimentalSaveFabricComment } from './mutations/experimentalSaveFabricComment';
import { experimentalFileUpload } from './mutations/experimentalFileUpload';
import { experimentalArchiveSpace } from './mutations/experimentalArchiveSpace';
import { experimentalMigratePages } from './mutations/experimentalMigratePages';
import { experimentalMigrateTemplate } from './mutations/experimentalMigrateTemplate';
import { experimentalRevertContent } from './mutations/experimentalRevertContent';
import { experimentalUpdateAutomationRuleWithConnection } from './mutations/experimentalUpdateAutomationRuleWithConnection';
import { experimentalQuickReload } from './queries/experimentalQuickReload';
import { experimentalContentBodyConvert } from './queries/experimentalContentBodyConvert';
import { experimentalGetAutomationRuleById } from './queries/experimentalGetAutomationRuleById';
import { experimentalAutomationUsage } from './queries/experimentalAutomationUsage';
import {
	experimentalTeamCalendars,
	experimentalTeamCalendarEvents,
	experimentalTeamCalendarsFormatDate,
	experimentalTeamCalendarsSubscribe,
	experimentalTeamCalendarWatchStatus,
	experimentalTeamCalendarTimezonesQuery,
	experimentalTeamCalendarJiraLinksQuery,
	experimentalTeamCalendarJiraOptionsQuery,
	experimentalTeamCalendarJiraDateFieldsQuery,
	experimentalTeamCalendarsSearch,
	experimentalTeamCalendarViewPreference,
	experimentalTeamCalendarSubscriberCount,
} from './queries/experimentalTeamCalendars';
import {
	experimentalTeamCalendarsAddEvent,
	experimentalTeamCalendarEdit,
	experimentalTeamCalendarResetSubscribeLink,
	experimentalTeamCalendarSubscribe,
	experimentalTeamCalendarDeleteEvent,
	experimentalTeamCalendarImport,
	experimentalTeamCalendarUpdateViewPreference,
	experimentalTeamCalendarEventTypeDefaultUpdate,
	experimentalTeamCalendarEventTypeCustomUpdate,
	experimentalTeamCalendarEventTypeCustomDelete,
	experimentalTeamCalendarJiraJQLValidate,
	experimentalTeamCalendarColors,
	experimentalTeamCalendarDeleteSingleEvent,
	experimentalTeamCalendarDeleteAllFutureEvents,
	experimentalTeamCalendarDelete,
	experimentalTeamCalendarRestriction,
} from './mutations/experimentalTeamCalendars';
import { experimentalFetchHaveISeenIt } from './queries/experimentalFetchHaveISeenIt';
import { experimentalSetHaveISeenIt } from './mutations/experimentalSetHaveISeenIt';
import { experimentalUpdateContentProperty } from './mutations/experimentalUpdateContentProperty';
import {
	experimentalTeamCalendar_Hide,
	experimentalTeamCalendar_Watch,
	experimentalTeamCalendar_EventType_Disable,
	experimentalTeamCalendarReminders,
	experimentalTeamCalendarPreferences,
} from './mutations/experimentalTeamCalendar_Preferences';
import { experimentalIntegrationsInstalled } from './queries/experimentalIntegrationsInstalled';
import { experimentalDraftSync } from './mutations/experimentalDraftSync';
import { experimentalPublishEditorContent } from './mutations/experimentalPublishEditorContent';
import { experimentalPublishPageAsBlog } from './mutations/experimentalPublishPageAsBlog';
import {
	experimentalSitePersonalization,
	experimentalUserPersonalization,
	experimentalSiteUserPersonalization,
} from './queries/experimentalPersonalization';
import { experimentalThemeSpaceHomeOverride } from './queries/experimentalThemeSpaceHomeOverride';
import { experimentalMarketplaceApps } from './queries/experimentalMarketplace';
import { experimentalResetCollabService } from './mutations/experimentalResetCollabService';
import { experimentalCancelScheduledPublish } from './mutations/experimentalCancelScheduledPublish';
import { experimentalConnectServlet } from './queries/experimentalConnectServlet';
import { experimentalNotifications } from './queries/experimentalNotifications';
import { experimentalConnectContext } from './queries/experimentalConnectContext';
import { experimentalCustomContentConnectModules } from './queries/experimentalCustomContentConnectModules';
import { experimentalEditorStartHeartbeat } from './mutations/experimentalEditorStartHeartbeat';
import { experimentalEditorStopHeartbeat } from './mutations/experimentalEditorStopHeartbeat';
import {
	experimentalCustomContentPage,
	experimentalCustomContentProperties,
	experimentalCustomContentPropertiesPage,
} from './queries/experimentalCustomContent';
import { experimentalUnlicensedPermission } from './queries/experimentalUnlicensedPermission';
import { experimentalRemoveUnlicensedPermission } from './mutations/experimentalRemoveUnlicensedPermission';
import { experimentalUpdateAutomationRule } from './mutations/experimentalUpdateAutomationRule';
import { experimentalAnalyticsViewsByDate } from './queries/experimentalAnalyticsViewsByDate';
import { experimentalAnalyticsContentViews } from './queries/experimentalAnalyticsContentViews';
import { experimentalAnalyticsActivityByDate } from './queries/experimentalAnalyticsActivityByDate';
import { experimentalAnalyticsActivityByUser } from './queries/experimentalAnalyticsActivityByUser';
import { experimentalAnalyticsUniqueSearchTermCount } from './queries/experimentalAnalyticsUniqueSearchTermCount';
import { experimentalAnalyticsSearchCountGroupByPage } from './queries/experimentalAnalyticsSearchCountGroupByPage';
import { experimentalAnalyticsSearchCountGroupBySpace } from './queries/experimentalAnalyticsSearchCountGroupBySpace';
import { experimentalAnalyticsViewsByCurrentUser } from './queries/experimentalAnalyticsViewsByCurrentUser';
import { experimentalAnalyticsSearchTimeseriesCTR } from './queries/experimentalAnalyticsSearchTimeseriesCTR';
import { experimentalAnalyticsSearchTimeseriesCount } from './queries/experimentalAnalyticsSearchTimeseriesCount';
import { experimentalAnalyticsExportCsvStatus } from './queries/experimentalAnalyticsExportCsvStatus';
import { experimentalAnalyticsSpaceContentViewExport } from './queries/experimentalAnalyticsSpaceContentViewExport';
import { experimentalAnalyticsRestrictionsBySpace } from './queries/experimentalAnalyticsRestrictionsBySpace';
import { experimentalAnalyticsSetRestrictionsBySpace } from './mutations/experimentalAnalyticsSetRestrictionsBySpace';
import { experimentalAnalyticsSiteRestrictions } from './queries/experimentalAnalyticsSiteRestrictions';
import { experimentalAnalyticsSetSiteRestrictions } from './mutations/experimentalAnalyticsSetSiteRestrictions';

export const resolvers = {
	Query: {
		experimentalAboutConfluence,
		experimentalAnalyticsActivityByDate,
		experimentalAnalyticsActivityBySpace,
		experimentalAnalyticsActivityByUser,
		experimentalAnalyticsContentViews,
		experimentalAnalyticsViewsByDate,
		experimentalAnalyticsUniqueSearchTermCount,
		experimentalAnalyticsRestrictionsBySpace,
		experimentalAnalyticsSiteRestrictions,
		experimentalAnalyticsSearchCountGroupByPage,
		experimentalAnalyticsSearchCountGroupBySpace,
		experimentalAnalyticsExportCsvStatus,
		experimentalAnalyticsSpaceContentViewExport,
		experimentalAnalyticsViewsByCurrentUser,
		experimentalAnalyticsSearchTimeseriesCTR,
		experimentalAnalyticsSearchTimeseriesCount,
		experimentalAutomationRuleConnections,
		experimentalAutomationRuleSummary,
		experimentalContentDraftDiff,
		experimentalDesPromotionEligibility,
		experimentalGenerateSpaceKey,
		experimentalGetCompleteOnboarding,
		experimentalKeyboardShortcutsStatus,
		experimentalLongTask,
		experimentalMacroMetadata,
		experimentalMacroPlaceholderADF,
		experimentalPromotedSpaces,
		experimentalOnboardingSpaceBlueprints,
		experimentalOnboardingTemplate,
		experimentalOpenInvite,
		experimentalSpace,
		experimentalSpaceProperties,
		experimentalTeamCalendars,
		experimentalTeamCalendarEvents,
		experimentalTeamCalendarsFormatDate,
		experimentalTeamCalendarsSubscribe,
		experimentalTeamCalendarWatchStatus,
		experimentalTeamCalendarTimezonesQuery,
		experimentalTeamCalendarJiraLinksQuery,
		experimentalTeamCalendarJiraOptionsQuery,
		experimentalTeamCalendarJiraDateFieldsQuery,
		experimentalTeamCalendarsSearch,
		experimentalTeamCalendarViewPreference,
		experimentalSynchronySnapshot,
		experimentalSynchronyJwt,
		experimentalCrossProductAdvancedSearch,
		experimentalResolvedInlineComments,
		experimentalEditorBreadcrumbs,
		experimentalQuickReload,
		experimentalContentBodyConvert,
		experimentalFetchHaveISeenIt,
		experimentalIntegrationsInstalled,
		experimentalCurrentUser,
		experimentalSystemInfoSettings,
		experimentalDefaultLogoForSpace,
		experimentalTeamCalendarSubscriberCount,
		experimentalUserPersonalization,
		experimentalSitePersonalization,
		experimentalSiteUserPersonalization,
		experimentalThemeSpaceHomeOverride,
		experimentalRelationsForContent,
		experimentalMarketplaceApps,
		experimentalConnectServlet,
		experimentalNotifications,
		experimentalConnectContext,
		experimentalCustomContentConnectModules,
		experimentalCustomContentPage,
		experimentalCustomContentProperties,
		experimentalCustomContentPropertiesPage,
		experimentalUnlicensedPermission,
		experimentalGetAutomationRuleById,
		experimentalAutomationUsage,
	},
	Mutation: {
		experimentalAddPersonalSpaceLink,
		experimentalAddCustomizedPersonalSpace,
		experimentalAddSpaceLink,
		experimentalCopyPageTree,
		experimentalCreateAutomationRuleFromTemplate,
		experimentalCreateDemoSpace,
		experimentalCreateSpecificSpace,
		experimentalDeleteComment,
		experimentalDeleteContentVersion,
		experimentalDisableKeyboardShortcuts,
		experimentalEnableKeyboardShortcuts,
		experimentalFavouriteSpace,
		experimentalGrantAccess,
		experimentalCreateBlankFabricPage,
		experimentalCreateFabricBlogpost,
		experimentalPublishPageByBlueprint,
		experimentalUpdateDraftWithBlueprint,
		experimentalPublishPageByTemplate,
		experimentalUpdateDraftWithTemplate,
		experimentalRemoveSpaceLink,
		experimentalRequestAccess,
		experimentalRestoreContentVersion,
		experimentalSetFeatureDiscovered,
		experimentalShare,
		experimentalSubmitFeedbackCollector,
		experimentalTeamCalendar_Hide,
		experimentalTeamCalendar_Watch,
		experimentalTeamCalendarsAddEvent,
		experimentalTeamCalendar_EventType_Disable,
		experimentalTeamCalendarReminders,
		experimentalTeamCalendarEventTypeDefaultUpdate,
		experimentalTeamCalendarEventTypeCustomUpdate,
		experimentalTeamCalendarEventTypeCustomDelete,
		experimentalTeamCalendarEdit,
		experimentalTeamCalendarResetSubscribeLink,
		experimentalTeamCalendarSubscribe,
		experimentalTeamCalendarImport,
		experimentalTeamCalendarUpdateViewPreference,
		experimentalTeamCalendarDeleteEvent,
		experimentalTeamCalendarDelete,
		experimentalUnfavouriteSpace,
		experimentalUpdateDesSettings,
		experimentalUpdateOpenInviteSettings,
		experimentalUpdateShortcutLinks,
		experimentalUpdateSpaceLogo,
		experimentalSaveFabricComment,
		experimentalFileUpload,
		experimentalMigratePages,
		experimentalMigrateTemplate,
		experimentalArchiveSpace,
		experimentalSetHaveISeenIt,
		experimentalDraftSync,
		experimentalTeamCalendarJiraJQLValidate,
		experimentalTeamCalendarRestriction,
		experimentalTeamCalendarColors,
		experimentalTeamCalendarDeleteSingleEvent,
		experimentalTeamCalendarDeleteAllFutureEvents,
		experimentalTeamCalendarPreferences,
		experimentalPublishEditorContent,
		experimentalUpdateContentProperty,
		experimentalPublishPageAsBlog,
		experimentalRevertContent,
		experimentalResetCollabService,
		experimentalCancelScheduledPublish,
		experimentalEditorStartHeartbeat,
		experimentalEditorStopHeartbeat,
		experimentalRemoveUnlicensedPermission,
		experimentalUpdateAutomationRule,
		experimentalUpdateAutomationRuleWithConnection,
		experimentalAnalyticsSetRestrictionsBySpace,
		experimentalAnalyticsSetSiteRestrictions,
	},
};
